"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MandatoryNotificationRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const communication_1 = require("./communication");
/**
 * Request body for sending mandatory notifications outside of in-UI flows including auth-related actions.
 */
exports.MandatoryNotificationRequest = typebox_1.Type.Object({
    channel: typebox_1.Type.Union([typebox_1.Type.Literal('email'), typebox_1.Type.Literal('sms')]),
    type: communication_1.MandatoryCommunicationType,
    to: typebox_1.Type.String(),
    templateData: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.String())),
});
//# sourceMappingURL=mandatory.js.map